import { render, staticRenderFns } from "./StaticRouteModal.vue?vue&type=template&id=2e8c6e85&scoped=true&"
import script from "./StaticRouteModal.vue?vue&type=script&lang=ts&"
export * from "./StaticRouteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c6e85",
  null
  
)

export default component.exports